import React from "react";
import logo from "../assets/logo.png";
import { desktopHeaderLinks } from "../lib/navLinks";
import { Link, NavLink } from "react-router";
export default function DesktopHeader() {
  return (
    <header className="sticky top-0 z-10 hidden h-28 w-full items-center justify-between bg-white px-12 py-8 lg:flex xl:h-32 xl:px-16 xl:py-10">
      <Link to="/">
        <img src={logo} className="h-12 xl:h-16" alt="access cv brand logo" />
      </Link>
      <ul className="flex gap-4 xl:gap-6">
        {desktopHeaderLinks.map((link, index) => {
          return (
            <li key={index}>
              <NavLink
                to={link.url}
                className={({ isActive }) =>
                  `${isActive && "text-secondaryColor hover:text-primaryColor"} text-base text-primaryColor hover:text-secondaryColor xl:text-lg`
                }
              >
                {link.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
      <Link
        className="rounded-3xl bg-primaryColor px-5 py-3 text-base font-bold text-secondaryColor shadow-md transition-all hover:bg-primaryHover hover:shadow-lg focus:bg-primaryHover focus:shadow-none active:bg-primaryHover active:shadow-none xl:px-8 xl:py-4 xl:text-lg"
        to={"/contact"}
      >
        Contact Us
      </Link>
    </header>
  );
}
